module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-07-21 at 8_1595371369197.f80fc0da.49";